import React from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { Divider, Radio, Checkbox, Form, Button, Input, DatePicker } from 'antd';
import moment from 'moment';
import './styles.css';

import logo_sade_negro from '../../../../../images/logo_sade_negro.png';

const optionsPL03calification = [
    { label: '1', value: '1' },
    { label: '2', value: '2' },
    { label: '3', value: '3' },
    { label: '4', value: '4' },
];

const optionsPL03_01 = [
    { label: 'Página web', value: 'Página web' },
    { label: 'Folletos', value: 'Folletos' },
    { label: 'Contrato de otros servicios', value: 'Contrato de otros servicios' },
    { label: 'Otros', value: 'Otros' },
];

const optionsPL03_02 = [
    { label: 'Precio', value: 'Precio' },
    { label: 'Calidad del servicio', value: 'Calidad del servicio' },
    { label: 'Confiabilidad técnica', value: 'Confiabilidad técnica' },
    { label: 'Flexibilidad ante pedidos especiales', value: 'Flexibilidad ante pedidos especiales' },
    { label: 'Responsabilidad', value: 'Responsabilidad' },
];

const PL03 = (props) => {
    const [form] = Form.useForm();
    const { surveyAssigned, userAssigned } = props;

    const handleSubmit = values => {
        props.onSubmit(values);
    }

    const handleReset = values => {
        form.resetFields()
    }

    return (
        <Grid className="PL03Cont">
            <div className="imageHeaderContPL03">
                <img className="imageHeaderPL03" src={logo_sade_negro} alt="Grupo SADE" />
            </div>
            <h1 className="titlePL03">Encuesta de satisfacción - Servicios electromecánicos</h1>
            <Row center="xs">
                <Col xs={0} md={1}></Col>
                <Col xs={6} md={4}>
                    <h3>Número de revisión:</h3><Input defaultValue="00" disabled/>
                </Col>
                <Col xs={0} md={2}></Col>
                <Col xs={6} md={4}>
                    <h3>Vigencia:</h3><Input defaultValue="Abril 2018" disabled/>
                </Col>
                <Col xs={0} md={1}></Col>
            </Row>
            <Divider type="horizontal" orientation="center">Encuesta informativa</Divider>
            <Row center="xs" end="md">
                <Col xs={12}>
                    <h3>Asignada el: {props.surveyAssigned ? moment(props.surveyAssigned.assignedDate, 'HH:mm DD/MM/YYYY').format('DD/MM/YYYY HH:mm') : "--/--/---- --:--"}</h3>
                </Col>
            </Row>
            <Form onFinish={handleSubmit} form={form} initialValues={{}}>
                <Row center="xs">
                    <Col xs={6}>
                        <DatePicker
                        placeholder="Fecha de realización"
                        format="DD/MM/YYYY HH:mm"
                        defaultValue={moment().utcOffset("-0300")}
                        showTime={{ defaultValue: moment('00:00', 'HH:mm') }}
                        disabled
                        />
                    </Col>
                </Row>
                <br />
                <Row start="xs">
                    <Col xs={6}>
                        <h4>Servicio realizado:</h4>
                    </Col>
                    <Col xs={6}>
                        <Form.Item name="PL03_service_performed" rules={[{ required: true, message: 'Por favor, complete el servicio realizado' }]}>
                            <Input maxLength="50"/>
                        </Form.Item>
                    </Col>
                </Row>
                <Row start="xs">
                    <Col xs={6}>
                        <h4>Cliente:</h4>
                    </Col>
                    <Col xs={6}>
                        <Form.Item name="PL03_client" rules={[{ required: true, message: 'Por favor, ingrese el cliente' }]}>
                            <Input maxLength="50"/>
                        </Form.Item>
                    </Col>
                </Row>
                <Row start="xs">
                    <Col xs={6}>
                        <h4>Cargo dentro de la institución/empresa:</h4>
                    </Col>
                    <Col xs={6}>
                        <Form.Item name="PL03_position" rules={[{ required: true, message: 'Por favor, ingrese el cargo' }]}>
                            <Input maxLength="50"/>
                        </Form.Item>
                    </Col>
                </Row>
                <h3>Señale con una cruz en la casilla correspondiente</h3>
                <h4><span className="boldCont">1</span>: MAL (cumplimiento insatisfactorio de los requisitos) | <span className="boldCont">2</span>: REGULAR (Cumple la mayoría de los requisitos, pero necesita mejorar) | <span className="boldCont">3</span>: BIEN (Cumple con los requisitos) | <span className="boldCont">4</span>: MUY BIEN (Excede los requisitos)</h4>
                <div className="calificationsContPL03">
                    <h3>A. PRESTACIÓN DEL SERVICIO</h3>
                    <Row center="xs">
                        <Col sm={12} md={4}>
                            <p className="labelContPL03">Presencia</p>
                        </Col>
                        <Col sm={12} md={8}>
                            <Form.Item name="PL03_calification_01" rules={[{ required: true, message: 'Por favor, seleccione al menos una opción' }]}>
                                <Radio.Group options={optionsPL03calification} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row center="xs">
                        <Col sm={12} md={4}>
                            <p className="labelContPL03">Puntualidad</p>
                        </Col>
                        <Col sm={12} md={8}>
                            <Form.Item name="PL03_calification_02" rules={[{ required: true, message: 'Por favor, seleccione al menos una opción' }]}>
                                <Radio.Group options={optionsPL03calification} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row center="xs">
                        <Col sm={12} md={4}>
                            <p className="labelContPL03">Trato personal</p>
                        </Col>
                        <Col sm={12} md={8}>
                            <Form.Item name="PL03_calification_03" rules={[{ required: true, message: 'Por favor, seleccione al menos una opción' }]}>
                                <Radio.Group options={optionsPL03calification} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row center="xs">
                        <Col sm={12} md={4}>
                            <p className="labelContPL03">Claridad en las explicaciones</p>
                        </Col>
                        <Col sm={12} md={8}>
                            <Form.Item name="PL03_calification_04" rules={[{ required: true, message: 'Por favor, seleccione al menos una opción' }]}>
                                <Radio.Group options={optionsPL03calification} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row center="xs">
                        <Col sm={12} md={4}>
                            <p className="labelContPL03">¿Cómo califica el soporte técnico recibido?</p>
                        </Col>
                        <Col sm={12} md={8}>
                            <Form.Item name="PL03_calification_05" rules={[{ required: true, message: 'Por favor, seleccione al menos una opción' }]}>
                                <Radio.Group options={optionsPL03calification} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row center="xs">
                        <Col sm={12} md={4}>
                            <p className="labelContPL03">S&D cumple con los plazos de entrega de informes y/o resultados</p>
                        </Col>
                        <Col sm={12} md={8}>
                            <Form.Item name="PL03_calification_06" rules={[{ required: true, message: 'Por favor, seleccione al menos una opción' }]}>
                                <Radio.Group options={optionsPL03calification} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row center="xs">
                        <Col sm={12} md={4}>
                            <p className="labelContPL03">S&D brinda respuesta adecuada a sus consultas técnicas</p>
                        </Col>
                        <Col sm={12} md={8}>
                            <Form.Item name="PL03_calification_07" rules={[{ required: true, message: 'Por favor, seleccione al menos una opción' }]}>
                                <Radio.Group options={optionsPL03calification} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row center="xs">
                        <Col sm={12} md={4}>
                            <p className="labelContPL03">¿Cómo califica el cumplimiento de las expectativas que tenía al solicitar el servicio?</p>
                        </Col>
                        <Col sm={12} md={8}>
                            <Form.Item name="PL03_calification_08" rules={[{ required: true, message: 'Por favor, seleccione al menos una opción' }]}>
                                <Radio.Group options={optionsPL03calification} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Divider type="horizontal" />
                    <h3>B. OFERTA</h3>
                    <Row center="xs">
                        <Col sm={12} md={4}>
                            <p className="labelContPL03">En general, la oferta se ajusta al servicio prestado</p>
                        </Col>
                        <Col sm={12} md={8}>
                            <Form.Item name="PL03_calification_09" rules={[{ required: true, message: 'Por favor, seleccione al menos una opción' }]}>
                                <Radio.Group options={optionsPL03calification} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Divider type="horizontal" />
                    <h3>C. OTROS</h3>
                    <Row center="xs">
                        <Col sm={12} md={4}>
                            <p className="labelContPL03">¿Cómo nos conoció?</p>
                        </Col>
                        <Col sm={12} md={8}>
                            <Form.Item name="PL03_calification_10" rules={[{ required: true, message: 'Por favor, seleccione al menos una opción' }]}>
                                <Checkbox.Group options={optionsPL03_01} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row center="xs">
                        <Col sm={12} md={4}>
                            <p className="labelContPL03">¿Cuál es su evaluación respecto de la comunicación?</p>
                        </Col>
                        <Col sm={12} md={8}>
                            <Form.Item name="PL03_calification_11" rules={[{ required: true, message: 'Por favor, seleccione al menos una opción' }]}>
                                <Radio.Group options={optionsPL03calification} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Divider type="horizontal" />
                    <h3>D. ELECCIÓN</h3>
                    <Row center="xs">
                        <Col sm={12} md={4}>
                            <p className="labelContPL03">Indique porque elije / nos sigue eligiendo</p>
                        </Col>
                        <Col sm={12} md={8}>
                            <Form.Item name="PL03_calification_12" rules={[{ required: true, message: 'Por favor, seleccione al menos una opción' }]}>
                                <Checkbox.Group options={optionsPL03_02} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row center="xs">
                        <Col sm={12} md={4}>
                            <p className="labelContPL03">Sugerencias / comentarios respecto al servicio brindado</p>
                        </Col>
                        <Col sm={12} md={8}>
                            <Form.Item name="PL03_calification_13" rules={[{ required: true, message: 'Por favor, seleccione al menos una opción' }]}>
                                <Input.TextArea placeholder="Comentario..." autoSize={{ minRows: 2 }} maxLength="300"/>
                            </Form.Item>
                        </Col>
                    </Row>
                </div>
                <br />
                <Row center="xs">
                    <Col xs={3} sm={3} md={3}></Col>
                    <Col xs={3} sm={3} md={3}>
                    {
                        props.isSaving ?
                            <Button type="primary" htmlType="submit" disabled={true} loading>
                                Enviar
                            </Button>
                            :
                            <Button type="primary" htmlType="submit" disabled={false}>
                                Enviar
                            </Button>
                    }
                    </Col>
                    <Col xs={3} sm={3} md={3}>
                        <Button onClick={handleReset}>
                            Limpiar
                        </Button>
                    </Col>
                    <Col xs={3} sm={3} md={3}></Col>
                </Row>
            </Form>
        </Grid>
    )
}

export default PL03;